import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

const BillingSuccess: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-[500px]">
      <Card className="w-full max-w-md">
        <CardContent className="pt-10 pb-8 text-center space-y-6">
          <div className="flex justify-center">
            <div className="flex items-center justify-center w-20 h-20 rounded-full bg-success/10">
              <CheckCircle className="w-10 h-10 text-success" />
            </div>
          </div>

          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">¡Pago exitoso!</h1>
            <p className="text-muted-foreground">
              Tu suscripción está siendo activada. En unos segundos estará disponible.
            </p>
          </div>

          <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
            <Button onClick={() => navigate('/dashboard')}>
              Ir al Dashboard
            </Button>
            <Button variant="outline" onClick={() => navigate('/billing')}>
              Ver suscripción
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default BillingSuccess;
